mutation stopAllCommunicationsForLead($input: StopAllCampaignsForLeadInput!) {
  stopAllCommunicationsForLead(input: $input)
}
